import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { AppFooter } from "../../components/main-components/footer";
import { hidePdf } from "../../helpers/parse-url";
import { useAuth } from "../../services/authentication/authentication.context";





export const PastQuestionDocument = () => {

    const width = window.innerWidth;


    const { hndSubscribed, userData } = useAuth();

    const tutorial = useLocation()?.state?.data;

    const docRef = useRef();




    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={tutorial?.title} />
            <div className="tutorial-detail" style={{ height: "100vh" }}>
                {(!hndSubscribed || hndSubscribed === false) &&
                    <div className="purchase-prompt">
                        <strong>Subscribe to view this tutorial</strong>
                        <a href="https://wa.me/whatsappphonenumber/?text=urlencodedtext">
                            <button
                                className="subscr-button"
                                onClick={() => window.location.href = `https://wa.me/+237675619077/?text=${encodeURI(`Hello my email is ${userData?.email}. I wish to subscribe to tutorials on notebook-bms`)}`}
                            >
                                <FontAwesomeIcon icon={faWhatsapp} color="#0f0" />
                            </button>
                        </a>
                    </div>
                }



                {hndSubscribed === true &&

                    <object
                        className="tutorial-file"
                        type="application/pdf"
                        data={hidePdf(tutorial?.pdfFile)}
                        onContextMenu={false}
                        ref={docRef}
                        onResize={() => docRef.current.resize()}
                    >

                        {width < 768 ?
                            <embed src={hidePdf(tutorial?.pdfFile)} width={"100%"} height={500} /> :
                            <div className="loading -text">Pdf loading...</div>
                        }

                    </object>
                }

            </div>
            <AppFooter />
        </div>
    );
}